/**
 * @param {Object} parameters
 * @param {String} parameters.playerElementId
 * @returns {Game}
 * @extends {jQuery}
 */
function Game(parameters) {
    var playerElementId = parameters.playerElementId;
    var $ = jQuery;

    /**
     * @lends Game.prototype
     */
    var game = $('<div class="Game"><div class="player"></div></div>');
    game.find('div.player').attr('id', playerElementId);

    var loading = Loading();
    var replaced;

    game.hideGame = function () {
        return game.addClass('hidden');
    };

    game.showGame = function () {
        return game.removeClass('hidden');
    };

    game.showLoading = function (message) {
        loading.setLabel(message).appendTo(game);
        return game;
    };

    game.setLoadingNotice = function (message) {
        loading.setNotice(message);
        return game;
    };

    game.hideLoading = function () {
        loading.remove();
        return game;
    };

    game.shutdown = function (message, actions) {
        return game.replaceGame(ErrorMessage(message, actions));
    };

    game.replaceGame = function (element) {
        game.hideGame();
        game.hideLoading();
        if (replaced) replaced.remove();
        replaced = $(element).appendTo(game);
        return game;
    };

    return game;

}
